import riot from 'riot';
riot.tag2('monitors', '<div class="table-container" if="{!parent.monitorsLoading && parent.monitors && parent.monitors.length > 0}"> <table class="table is-striped is-fullwidth"> <thead> <tr> <th>Activity Code</th> <th>Activity Step</th> <th>Method</th> <th>Period</th> <th>Last Measurement</th> <th>Icon</th> <th>Action</th> </tr> </thead> <tbody> <tr each="{m in parent.monitors}"> <th>{m.activity_ref}</th> <td>{m.activity_step}</td> <td>{m.method}</td> <td>{m.period}</td> <td>{prettyTimestamp(m.last_run)}</td> <td> <figure class="image is-48x48"><img riot-src="img/sensors/{m.method}.jpg" alt="{m.method} Icon"></figure> </td> <td><button class="button is-danger is-small" onclick="{cancelMonitorClick}">Cancel</button></td> </tr> </tbody> </table> </div> <div class="notification is-warning is-light" if="{!parent.monitorsLoading && parent.monitors && parent.monitors.length == 0}">No monitors enabled.</div>', '', '', function(opts) {
        var self = this;

        this.prettyTimestamp = function(epoch_ms) {

            if (!epoch_ms || new Date(epoch_ms).getTime() === 0) {
                return 'N/A';
            }
            return new Date(epoch_ms).toLocaleString();
        }.bind(this)

        this.cancelMonitorClick = function(event) {

            var monitor = event.item.m;
            self.parent.cancelMonitor(monitor)
        }.bind(this)
});
